import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Observable } from 'rxjs';
import { PublicBannerCollectionItem } from '../../models/public-banner-collection-item';
import { PublicBannerDataSourceService } from '../../services/public-banner-data-source.service';
import { Carousel } from 'primeng/carousel';
import { BannerLocationType } from '../../../shared/enums/banner-location-type';
import { isNotNil } from '@web/utils';
import { PublicSubscribeBannerCarouselItemComponent } from '../../components/public-subscribe-banner-carousel-item/public-subscribe-banner-carousel-item.component';

@Component({
  selector: 'app-public-subscribe-banner-carousel',
  imports: [Carousel, CommonModule, PublicSubscribeBannerCarouselItemComponent],
  templateUrl: './public-subscribe-banner-carousel.component.html',
  styleUrl: './public-subscribe-banner-carousel.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PublicSubscribeBannerCarouselComponent {
  private readonly bannerDataSource = inject(PublicBannerDataSourceService);

  protected readonly banners$ = this.bannersSource();
  protected readonly isNotNil = isNotNil;

  protected isMoreThanOne(banners: PublicBannerCollectionItem[]): boolean {
    return banners.length > 1;
  }

  private bannersSource(): Observable<PublicBannerCollectionItem[]> {
    return this.bannerDataSource.fetchCollection({
      type: BannerLocationType.SubscribePage,
    });
  }
}
